import script from "./BulmaTooltip.vue?vue&type=script&setup=true&lang=ts"
export * from "./BulmaTooltip.vue?vue&type=script&setup=true&lang=ts"

import "./BulmaTooltip.vue?vue&type=style&index=0&id=d9fd1146&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9fd1146"]])

export default __exports__